import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, CircularProgress } from "@mui/material";
import CustomTextField from '../common/CustomTextField';
import CustomButton from '../common/CustomButton';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { SaveRounded } from '@mui/icons-material';
import { REGISTER_PATH, VERIFY_OTP } from '../../services/apiRoutes'
import { genericPost } from '../../services/authServices';
import MessageBox from '../common/CustomMessageBox'
import CustomPasswordFeild from "../common/CustomPasswordFeild";
import CustomMobileField from "../common/CustomMobileField";
import { getCountries } from "../../services/CommonServices";

// Validation Schema
const validationSchema = Yup.object({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  mobile: Yup.string().required('Mobile Number is required'),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),

});

const otpSchema = Yup.object({
  otp: Yup.string()
    .length(6, "OTP must be 6 digits")
    .required("OTP required"),
});

const Register = ({ setTabValue }) => {
  const [conutries, setConutries] = useState([]);
  const [showOtp, setShowOtp] = useState(false);
  const [savedFormData, setSavedFormData] = useState(null);
  const [generatedOtp, setGeneratedOtp] = useState("");


  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  })

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    phonecodeId: '',
    password: '',
  };


  /* -------- GENERATE RANDOM 6 DIGIT OTP -------- */
  const generateOtp = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  /* -------- SEND OTP TO BACKEND -------- */
  const sendOtp = async (email, otp) => {
    try {

      const payload = {
        email,
        generateOtp: otp,
      };
      const response = await genericPost(VERIFY_OTP, payload);
      // ✅ Handle backend response properly
      if (response?.status === 200) {
        setMessage({
          open: true,
          text: response?.data?.message || "OTP sent to your email address",
          type: "success",
        });
        return response.data;
      }
      // ❌ Handle unexpected success response
      throw new Error("Unexpected server response");
    } catch (error) {
      console.error("Send OTP Error:", error);
      setMessage({
        open: true,
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to send OTP",
        type: "error",
      });
    }
  };


  /* -------- STEP 1: REGISTER (GENERATE & SEND OTP) -------- */
  const handleRegister = async (values, { setSubmitting }) => {
    try {
      const otp = generateOtp();

      // Save locally for later verification
      setGeneratedOtp(otp);
      setSavedFormData(values);
      setShowOtp(true);

      await sendOtp(values.email, otp);

      console.log("Generated OTP:", otp); // optional for debugging
    } catch (err) {
      setMessage({
        open: true,
        text: "Registration failed",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* -------- STEP 2: VERIFY OTP -------- */
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (values.otp !== generatedOtp) {
        setMessage({
          open: true,
          text: "Invalid OTP",
          type: "error",
        });
        return;
      }

      const response = await genericPost(REGISTER_PATH, savedFormData);

      switch (response.status) {
        case 200:
          setMessage({
            open: true,
            text: "Registration successful",
            type: "success",
          });
          setTimeout(() => {
            setTabValue("login");
          }, 3000);
          break;
        case 400:
          setMessage({ open: true, text: response.data?.message || "Bad request", type: "error" });
          break;
        case 401:
          setMessage({ open: true, text: "Unauthorized access", type: "error" });
          break;
        case 409:
          setMessage({ open: true, text: "User already exists", type: "error" });
          break;
        default:
          setMessage({ open: true, text: "Something went wrong", type: "error" });
      }
    } catch (error) {
      const status = error?.response?.status;
      const apiMessage = error?.response?.data?.message;
      setMessage({
        open: true,
        text: apiMessage || (status === 500 ? "Server error. Please try again later." : "Registration failed"),
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* -------- OTP RESEND FUNCTION -------- */
  const handleResendOtp = async () => {
    if (!savedFormData?.email) return;

    const newOtp = generateOtp();
    setGeneratedOtp(newOtp);
    await sendOtp(savedFormData.email, newOtp);

    console.log("Resent OTP:", newOtp); // optional for debugging
  };


  // const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  //   try {
  //     const response = await genericPost(REGISTER_PATH, values);

  //     if (response.status === 200) {
  //       setMessage({
  //         open: true,
  //         text: 'User registered successfully',
  //         type: 'success'
  //       });
  //       // setTabValue('login');
  //       resetForm();
  //     }
  //     else if (response.status === 409) {
  //       setMessage({
  //         open: true,
  //         text: response.message || 'User with this email/Mobile already exists',
  //         type: 'error',
  //       });
  //     }
  //     else {
  //       setMessage({
  //         open: true,
  //         text: 'User with this email already exists',
  //         type: 'error'
  //       });
  //     }

  //   } catch (error) {
  //     if (error.response && error.response.status === 409) {
  //       setMessage({
  //         open: true,
  //         text: 'User with this email already exists',
  //         type: 'error'
  //       });
  //     } else {
  //       setMessage({
  //         open: true,
  //         text: 'Something went wrong',
  //         type: 'error'
  //       });
  //     }
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const getCommonData = async () => {
    const getConutriesData = await getCountries()
    setConutries(getConutriesData)
  }
  useEffect(() => {
    getCommonData()
  }, [])

  return (
    <>
      {/* ================= REGISTER FORM ================= */}
      {!showOtp && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleRegister}

        >
          {({ errors, touched, isSubmitting, values, setFieldValue }) => (
            <Form>
              <Box sx={{ mt: 2, color: "#404040" }}>
                <Typography
                  variant="h6"
                  sx={{ fontSize: "35px", fontWeight: "600", lineHeight: 1 }}
                >
                  Welcome!
                </Typography>
                <Typography variant="h6" sx={{ fontSize: "25px", fontWeight: "500" }}>
                  Create your account
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Field
                      name="firstName"
                      as={CustomTextField}
                      required
                      placeholder="Enter First Name"
                      fullWidth
                      error={touched.firstName && !!errors.firstName}
                      helperText={touched.firstName && errors.firstName}

                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      name="lastName"
                      as={CustomTextField}
                      required
                      placeholder="Enter Last Name"
                      fullWidth
                      error={touched.lastName && !!errors.lastName}
                      helperText={touched.lastName && errors.lastName}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      name="email"
                      type="email"
                      as={CustomTextField}
                      required
                      placeholder="Enter Email"
                      fullWidth
                      error={touched.email && !!errors.email}
                      helperText={touched.email && errors.email}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      type="number"
                      name="mobile"
                      as={CustomMobileField}
                      required
                      placeholder="Enter Mobile Number"
                      fullWidth
                      error={touched.mobile && !!errors.mobile}
                      helperText={touched.mobile && errors.mobile}
                      countryCode={conutries.find((c) => c.id === values.phonecodeId)}
                      setFieldValue={setFieldValue}
                    />

                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      name="password"
                      type="password"
                      as={CustomPasswordFeild}
                      required
                      placeholder="Enter Password"
                      fullWidth
                      error={touched.password && !!errors.password}
                      helperText={touched.password && errors.password}
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                </Grid>

                <CustomButton
                  type="submit"
                  title={
                    isSubmitting ? (
                      <>
                        <CircularProgress size={20} color="inherit" />
                        <span style={{ marginLeft: 10 }}>
                          Register
                        </span>
                      </>
                    ) : (
                      <span style={{}}>
                        Register
                      </span>
                    )
                  }
                  size="small"
                  variant="contained"
                />
              </Box>
            </Form>
          )}
        </Formik>
      )}

      {/* ================= OTP FORM ================= */}
      {showOtp && (
        <Formik initialValues={{ otp: "" }} validationSchema={otpSchema} onSubmit={handleSubmit}>
          {/* {({ isSubmitting }) => ( */}
          {({ errors, touched, isSubmitting, values, setFieldValue }) => (
            <Form>
              <Typography variant="h6">Verify OTP</Typography>

              <Field as={CustomTextField} value={savedFormData?.email} disabled fullWidth />

              <Field
                name="otp"
                as={CustomTextField}
                placeholder="Enter OTP"
                error={touched.otp && !!errors.otp}
                helperText={touched.otp && errors.otp}
                fullWidth
              />

              <Grid container spacing={1} alignItems="center" style={{ marginTop: 10 }}>
                <Grid item>
                  <CustomButton
                    type="submit"
                    title={isSubmitting ? <CircularProgress size={20} /> : "Verify OTP"}
                  />
                </Grid>

                <Grid item>
                  <CustomButton type="button" title="Resend OTP" onClick={handleResendOtp} />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}


      <MessageBox
        open={message.open}
        onClose={() => setMessage({ ...message, open: false })}
        message={message.text}
        type={message.type}
      />
    </>
  );
};

export default Register;